import { setSidebarOpenTab } from '@/atoms/persistedPreferencesAtoms';
import { type FooterMoreRowDescriptor } from '@/components/layout/Navigation/sidebar/footer-rail/footer-rail-context';
import { useIsConciergePocEnabled } from '@/features/flags';
import { ConciergeBell } from 'lucide-react';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useMobilePanel } from '../mobile/use-mobile-panel';
import { useIsRouteActive } from './useIsRouteActive';

/** The More row for Concierge. Its own hook because the caller is at its line cap. */
export function useConciergeMoreDescriptor(): FooterMoreRowDescriptor | null {
  const intl = useIntl();
  const enableConcierge = useIsConciergePocEnabled();
  const isRouteActive = useIsRouteActive();
  const { dismissMobileSidebar } = useMobilePanel();

  return useMemo(() => {
    if (!enableConcierge) return null;
    return {
      id: 'concierge',
      label: intl.formatMessage({
        defaultMessage: 'Concierge',
        id: '9G+x4ke1z0',
        description: 'Sidebar entry for the concierge agent request list',
      }),
      icon: <ConciergeBell />,
      href: '/concierge',
      testId: 'sidebar-link-view-concierge',
      isActive: isRouteActive('/concierge'),
      onSelect: () => {
        setSidebarOpenTab(undefined);
        dismissMobileSidebar();
      },
    };
  }, [enableConcierge, intl, isRouteActive, dismissMobileSidebar]);
}
